module.exports = __webpack_public_path__ + "img/login-bg.706c118a.jpg";